import { ReactElement } from 'react';
import { Stack } from '@mui/material';

import DashboardVariantV2GiverActionsWidgetIntegrationsAction from './Integrations';
import DashboardVariantV2GiverActionsWidgetSettingsAction from './Settings';

const DashboardVariantV2GiverActionsWidget = (): ReactElement => (
  <Stack spacing={1.5}>
    <DashboardVariantV2GiverActionsWidgetIntegrationsAction />

    <DashboardVariantV2GiverActionsWidgetSettingsAction />
  </Stack>
);

export default DashboardVariantV2GiverActionsWidget;
